// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"01c82ecb","142":"68b27677","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};